<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ attrs }">
      <!-- v-on="on" -->
      <v-btn
        small
        color="success"
        v-bind="attrs"
        :loading="isloading"
        @click="ShowBalance"
        icon
      >
        <v-icon> fas fa-user-cog</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="indigo white--text" primary-title>
        {{ CustomerID.FullName }}
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row class="justify-space-around">
          <v-col cols="12" md="4" sm="12" lg="4">
            <v-card light class="shape">
              <v-toolbar color="white">
                <!-- <v-btn icon color="black">
                <v-icon>mdi-pen</v-icon>
              </v-btn> -->
                <EditeClient
                  :BaseURL="BaseURL"
                  :ClientInfo="CustomerID"
                ></EditeClient>
                <v-toolbar-title>{{ CustomerID.FullName }}</v-toolbar-title>

                <v-spacer></v-spacer>
                <!-- <AddUser :ClientInfo="CustomerID"></AddUser> -->
              </v-toolbar>
              <v-card-text class="black--text subtitle-1">
                <v-row>
                  <!-- <v-col>{{ CustomerID }}</v-col> -->
                  <v-col cols="6"> Phone:</v-col>
                  <v-col cols="6">{{ CustomerID.Qphone }}</v-col>
                  <v-col cols="6"> ID Number:</v-col>
                  <v-col cols="6">{{ CustomerID.IDNomber }}</v-col>
                  <v-col cols="6"> Reg Date:</v-col>
                  <v-col cols="6"> {{ CustomerID.date }}</v-col>
                  <v-col cols="6"> Account:</v-col>
                  <v-col cols="6">{{ CustomerID.AccountNumber }}</v-col>
                  <v-col cols="6"> Limit:</v-col>
                  <v-col cols="6">{{ CustomerID.limit || "Unlimited" }}</v-col>
                </v-row>
              </v-card-text>
              <!-- <v-divider></v-divider> -->
              <v-card-actions class="yellow darken-1 justify-center">
                <!-- <p v-if="Balance.length === 0">
                  {{ EmptyMessage }}
                </p> -->
                <DisplayCash :Balance="Balance" :isloading="isloading">
                </DisplayCash>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" sm="12" lg="4">
            <v-card class="shape">
              <v-card-title primary-title class="justify-center headline">
                {{ CustomerID.FullName }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-lg>
                  <v-row>
                    <v-col cols="12">
                      <deposit
                        :BaseURL="BaseURL"
                        :Finished="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                      ></deposit>
                    </v-col>
                    <v-col cols="12">
                      <withdraw
                        :BaseURL="BaseURL"
                        :FinishedWithdrow="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                      ></withdraw>
                    </v-col>
                    <v-col cols="12">
                      <Exchange
                        btnColor="error"
                        :Finished="AffterDeposit"
                        :AccountNumber="CustomerID.AccountNumber"
                      ></Exchange>
                    </v-col>
                    <v-col cols="12">
                      <viewTran
                        btnColor="primary"
                        :BaseURL="BaseURL"
                        :isIcon="false"
                        queryKey="AccountNumber"
                        :Title="CustomerID.FullName"
                        :TranInfo="CustomerID"
                      >
                        <!-- Qaas Delete Icon -->
                        <template #btnSlot>
                          View Tran
                        </template>
                        <template v-slot:Ref="{ row: item }">
                          <base-row-layout>
                            <!-- Base Delete icon -->
                            <div>
                              <BaseDelete
                                v-if="UsersToken.UserType === 'Admin'"
                                :OnFinish="
                                  () => {
                                    item.OnSearch(item.fromDate, item.toDate);
                                    AffterDeposit();
                                  }
                                "
                                :DelQuery="{ Ref: item.Ref }"
                                DelUrl="/Reports/deleteRef"
                              >
                                <template #title>
                                  DELETE
                                  <span class="black--text">{{
                                    item.Description
                                  }}</span>
                                </template>

                                <v-row>
                                  <v-col>{{ item.date }}</v-col>

                                  <v-col>{{ item.Details }}</v-col>
                                  <v-col>{{
                                    item.Amount && item.Amount.toLocaleString()
                                  }}</v-col>
                                </v-row>
                              </BaseDelete>
                            </div>
                            <!-- Edite Date and Details -->
                            <div>
                              <base-edite-date
                                :Info="item"
                                :BaseURL="BaseURL"
                                :FinishedWithdrow="
                                  () => {
                                    item.OnSearch(item.fromDate, item.toDate);
                                  }
                                "
                              ></base-edite-date>
                            </div>
                          </base-row-layout>
                        </template>
                      </viewTran>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
// import _ from "loadash"
import deposit from "./Deposit";
import withdraw from "./Withdraw";
// import invest from "@/components/client/invest";
// import Exchange from "@/components/client/clientExchange";
// import AddUser from "@/components/client/AddUser";

import EditeClient from "./editClient.vue";
import DisplayCash from "@/components/util/displayCash.vue";
import Exchange from "./clientExchange";
import { mapGetters } from "vuex";

export default {
  components: {
    deposit,
    withdraw,
    Exchange,
    viewTran: () => import("@/components/util/TranSactionView.vue"),
    // invest,
    // // AddUser,
    EditeClient,
    DisplayCash,
  },
  props: {
    CustomerID: { type: Object, required: true },
    BaseURL: { type: String, required: true },
  },
  data() {
    return {
      selection: -1,
      dialog: false,
      isloading: false,
      EmptyMessage: "",
      Balance: [],

      Projects: [],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
  },
  methods: {
    close() {
      this.dialog = false;
    },
    AffterDeposit() {
      this.ShowBalance();
    },
    shareRefresh(project) {
      this.Projects = project;
      //   console.log(amount);
    },
    getReq(Url = `${this.BaseURL}/balance`, query = null) {
      if (!query)
        query = {
          AccountNumber: this.CustomerID.AccountNumber,
        };
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: Url,
        query: query,
      });
    },
    ShowBalance() {
      this.isloading = true;
      this.Balance = [];
      this.EmptyMessage = "";
      // console.log(ID);

      this.getReq()
        .then(result => {
          this.dialog = true;
          this.isloading = false;
          if (result.data.length === 0)
            this.EmptyMessage = "This Account is Empty";
          // console.log(result);

          this.Balance = result.data;

          // this.Balance.Name = item.FullName;
        })
        .catch(() => {
          this.dialog = false;
          this.isloading = false;
          this.EmptyMessage = "something is wrong plz try again!!!";
          // console.log(error);
        });
    },
  },
  created() {
    // this.ShowBalance(this.CustomerID);
  },
};
</script>
<style scoped>
.shape {
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
</style>
